module.exports = __webpack_public_path__ + "media/images/icon-chart-down-gray-765f94bdb00f70b2017c6c7e884a0372.svg";